import { useLocation, matchPath } from 'react-router-dom'
import { AppsRoutes } from '@wellesley/router'

export const useIsItemActive = (link?: AppsRoutes) => {
  const location = useLocation()
  return !!matchPath(link || '', location.pathname)
}
